export default __webpack_public_path__ + "static/media/simrunChopra2.a7da52e3.jpg";